/* HNY+ UpCart theme layer (B2, theme-controlled). Shadow DOM must be OFF.
   1) Gruns-style subtotal discount line. Strike per item = the variant's Shopify compare-at
      (UpCart fetches it and exposes it as item.compareAtPrice), else the buy box's _cmp stamp,
      else $4.00/gel. compareAtPrice comes first so an Intelligems duplicate variant strikes
      its own compare-at rather than the original product's.
   2) Line-item text tidy: rename title, split Supply into 2 clean lines, hide size/plan. */
(function () {
  var GEL_MSRP = 400; // cents per gel ($4.00) — defensible reorder rate
  var GIFT_VARIANTS = [47809958019177, 47810014019689]; // Fueling Guide, Future Mystery Gifts
  var cartHasSub = false; // set from /cart.js: true when every non-gift item is a subscription (subs ship free)
  var GIFT_TITLE_RE = /fueling guide|mystery gift/i;
  var QUARTERLY_PLAN = 1901527145;     // Skio 90-Day selling plan
  var GIFT_HANDLE = { 47809958019177: 'fueling-guide', 47810014019689: 'mystery-gift' };
  var GIFT_DESC = { // hardcoded fallback; live copy pulled from /products/{handle}.js
    47809958019177: 'A subscribers-only gift to jumpstart your HNY+ experience.',
    47810014019689: 'Surprise gifts added to your future shipments.'
  };
  var descCache = {};
  function giftKeyFromTitle(t) {
    if (/fueling guide/i.test(t)) return 47809958019177;
    if (/mystery gift/i.test(t)) return 47810014019689;
    return null;
  }
  function fmt(c) { return '$' + (c / 100).toFixed(2); }
  function packSize(item) {
    var m = String(item && item.title || '').match(/(\d+)\s*pack/i);
    return m ? parseInt(m[1], 10) : 0;
  }
  // per-unit strike anchor (cents): variant compare-at from UpCart, else buy box _cmp, else $4/gel
  function unitStrike(it) {
    var cap = parseInt(it && it.compareAtPrice, 10);
    if (cap > 0) return cap;
    var cmp = it && it.properties && it.properties._cmp;
    if (cmp) return parseInt(cmp, 10);
    var ps = packSize(it);
    return ps > 0 ? ps * GEL_MSRP : 0;
  }

  // ---- 1) subtotal discount line ----
  function compute() {
    var cart = window.upcartGetCart && window.upcartGetCart();
    if (!cart || !cart.items || !cart.items.length) return null;
    var strike = 0;
    cart.items.forEach(function (it) {
      var qty = it.quantity || 1;
      var isGift = it.isGiftCard || it.isRewardItem || GIFT_TITLE_RE.test(it.title || '');
      var unit = isGift ? 0 : unitStrike(it);
      if (unit > 0) strike += unit * qty;
      else strike += (it.finalLinePrice || 0);
    });
    var actual = cart.total;
    if (!(strike > actual)) return null;
    return { strike: strike, actual: actual, pct: Math.round((strike - actual) / strike * 100) };
  }
  function decorateSubtotal() {
    var valEl = document.querySelector('[class*="cartSubtotalValue" i]');
    if (!valEl) return;
    var old = valEl.querySelector('.hny-disc');
    var d = compute();
    if (!d) { if (old) old.remove(); return; }
    // idempotent: unconditional remove+reinsert here re-triggers the CartPopup
    // MutationObserver and self-sustains an infinite loop (frozen cart)
    var sig = d.pct + '|' + d.strike;
    if (old && old.getAttribute('data-hny-sig') === sig) return;
    if (old) old.remove();
    var wrap = document.createElement('span');
    wrap.className = 'hny-disc';
    wrap.setAttribute('data-hny-sig', sig);
    wrap.innerHTML =
      '<span class="hny-disc-pill"><span>' + d.pct + '% OFF</span></span>' +
      '<span class="hny-disc-strike">' + fmt(d.strike) + '</span>';
    valEl.insertBefore(wrap, valEl.firstChild);
  }

  // ---- 2) line-item text tidy ----
  function restyleLineItems() {
    document.querySelectorAll('.upcart-public-cart-item').forEach(function (li) {
      if (li.querySelector('.hny-li-detail')) return;
      var props = li.querySelector('.upcart-public-component-product-tile__properties');
      if (!props) return;
      // quarterly buy box -> "90-Day Supply: 1-3 weekly gels" ; legacy PDP/V3 buy box -> "Plan: 12-Pack every 1 mo"
      var detailEl = [].slice.call(props.querySelectorAll('[class*="key-value-pair"]'))
        .filter(function (e) { return /supply\s*:|plan\s*:/i.test(e.textContent); })[0];
      if (!detailEl) return;
      var raw = detailEl.textContent.trim();
      var ci = raw.indexOf(':');
      var left = (ci === -1 ? raw : raw.slice(0, ci)).trim();
      var right = ci === -1 ? '' : raw.slice(ci + 1).trim();
      var row1, months = 0;
      if (/supply/i.test(left)) {
        var freq = right.replace(/\b\w/g, function (c) { return c.toUpperCase(); });
        row1 = left + (freq ? ' / ' + freq : '');
        var days = parseInt((left.match(/(\d+)/) || [])[1], 10);
        months = days ? Math.round(days / 30) : 0;
      } else {
        // "Plan" -> right = "12-Pack every 1 mo"
        row1 = (right.split(/\s+every\s+/i)[0] || '').trim();
        months = parseInt((right.match(/every\s+(\d+)/i) || [])[1], 10);
      }
      var delivery = months ? (months <= 1 ? 'Delivered every month' : 'Delivered every ' + months + ' months') : '';
      // hide UpCart's native property block (its text color re-renders + can't be overridden), inject our own
      // in the SAME column slot the native props occupied (a full-width block under the title, above the price)
      props.style.setProperty('display', 'none', 'important');
      var det = document.createElement('div');
      det.className = 'hny-li-detail';
      det.innerHTML = '<span class="hny-li-l1">' + row1 + '</span>' +
        (delivery ? '<span class="hny-li-l2">' + delivery + '</span>' : '');
      props.parentNode.insertBefore(det, props);
    });
  }

  // ---- "Free Gift" label above the gift line ----
  function labelGifts() {
    document.querySelectorAll('.upcart-public-cart-item').forEach(function (li) {
      var title = li.querySelector('.upcart-public-component-product-tile__product-title');
      var isGift = title && GIFT_TITLE_RE.test(title.textContent);
      if (!isGift) return;
      li.classList.add('hny-gift-item'); // CSS hides the qty stepper on gifts
      var oldLbl = li.querySelector('.hny-freegift-label'); if (oldLbl) oldLbl.remove();
      if (li.querySelector('.hny-freegift-pill')) return;
      var priceGroup = li.querySelector('.upcart-public-component-product-tile__price-group');
      if (!priceGroup) return;
      var pill = document.createElement('span');
      pill.className = 'upcart-internal-component-tag upcart-public-component-tag hny-freegift-pill';
      pill.innerHTML = '<span class="upcart-internal-component-tag__icon upcart-public-component-tag__icon">' +
        '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 12 20 22 4 22 4 12"/><rect x="2" y="7" width="20" height="5"/><line x1="12" y1="22" x2="12" y2="7"/><path d="M12 7H7.5a2.5 2.5 0 0 1 0-5C11 2 12 7 12 7z"/><path d="M12 7h4.5a2.5 2.5 0 0 0 0-5C13 2 12 7 12 7z"/></svg></span>' +
        '<span class="upcart-internal-component-tag__text upcart-public-component-tag__text">FREE GIFT</span>';
      priceGroup.appendChild(pill); // sits right of the $0.00 / strike (CSS order:3)
    });
  }

  // ---- gift description line (Gruns-style, under the title) ----
  function fetchDesc(vid) {
    var h = GIFT_HANDLE[vid];
    if (!h || descCache[vid]) return;
    fetch('/products/' + h + '.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (p) {
        if (!p || !p.description) return;
        var tmp = document.createElement('div'); tmp.innerHTML = p.description;
        var txt = (tmp.textContent || '').replace(/\s+/g, ' ').trim();
        if (!txt) return;
        descCache[vid] = txt;
        document.querySelectorAll('.upcart-public-cart-item').forEach(function (li) {
          var title = li.querySelector('.upcart-public-component-product-tile__product-title');
          if (title && giftKeyFromTitle(title.textContent) === vid) {
            var el = li.querySelector('.hny-freegift-desc'); if (el) el.textContent = txt;
          }
        });
      }).catch(function () {});
  }
  function describeGifts() {
    document.querySelectorAll('.upcart-public-cart-item').forEach(function (li) {
      var title = li.querySelector('.upcart-public-component-product-tile__product-title');
      if (!title) return;
      var vid = giftKeyFromTitle(title.textContent);
      if (!vid || li.querySelector('.hny-freegift-desc')) return;
      var d = document.createElement('div');
      d.className = 'hny-freegift-desc';
      d.textContent = descCache[vid] || GIFT_DESC[vid];
      // insert into the vertical info column, directly above the price (Gruns-style)
      var priceGroup = li.querySelector('.upcart-public-component-product-tile__price-group')
        || li.querySelector('.upcart-public-component-product-tile__price');
      if (priceGroup && priceGroup.parentNode) priceGroup.parentNode.insertBefore(d, priceGroup);
      else title.parentNode.insertBefore(d, title.nextSibling);
      if (!descCache[vid]) fetchDesc(vid);
    });
  }

  // ---- kill product links in the cart (no click-through to PDPs; gifts are Unlisted and must stay unreachable) ----
  function disableItemLinks() {
    document.querySelectorAll('.upcart-public-cart-item a[href*="/products/"]').forEach(function (a) {
      if (a.dataset.hnyNolink) return;
      a.dataset.hnyNolink = '1';
      a.removeAttribute('href');
      a.setAttribute('tabindex', '-1');
      a.style.pointerEvents = 'none';
      a.style.cursor = 'default';
      a.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); });
    });
  }

  function injectGuarantee() {
    var btn = document.querySelector('.upcart-checkout-button');
    if (!btn || !btn.parentElement) return;
    if (document.querySelector('.hny-guarantee')) return;
    var el = document.createElement('div');
    el.className = 'hny-guarantee';
    el.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"></polyline></svg><span>Money-back guarantee</span>';
    btn.parentElement.insertBefore(el, btn.nextSibling);
  }

  // ---- gift guard: remove the free Fueling Guide if no 90-Day item remains ----
  var guardBusy = false;
  function enforceGiftGuard() {
    if (guardBusy) return;
    guardBusy = true;
    fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var gifts = (cart.items || []).filter(function (it) { return GIFT_VARIANTS.indexOf(it.variant_id) !== -1; });
        if (!gifts.length) { guardBusy = false; return; }
        var hasQuarterly = (cart.items || []).some(function (it) {
          if (GIFT_VARIANTS.indexOf(it.variant_id) !== -1) return false;
          var sp = it.selling_plan_allocation && it.selling_plan_allocation.selling_plan;
          return sp && (sp.id === QUARTERLY_PLAN || /3\s*month|90.?day|quarter/i.test(sp.name || ''));
        });
        if (hasQuarterly) { guardBusy = false; return; }
        var updates = {};
        gifts.forEach(function (g) { updates[g.key] = 0; });
        return fetch('/cart/update.js', {
          method: 'POST', headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ updates: updates })
        }).then(function () { guardBusy = false; if (window.upcartRefreshCart) window.upcartRefreshCart(); });
      })
      .catch(function () { guardBusy = false; });
  }

  function needsApply() {
    if (!document.querySelector('[class*="cartSubtotalValue" i] .hny-disc') && compute()) return true;
    if (document.querySelector('.upcart-checkout-button') && !document.querySelector('.hny-guarantee')) return true;
    var rw = document.querySelector('.upcart-public-rewards');
    if (rw) {
      var rm = rw.querySelector('.upcart-public-rewards__message');
      if (cartHasSub && rm && rm.getAttribute('data-hny-ship') !== '1') return true;
      if (!cartHasSub && rw.classList.contains('hny-ship-free')) return true;
    }
    var sc = window.upcartGetCart && window.upcartGetCart();
    var slis = [].slice.call(document.querySelectorAll('.upcart-public-cart-item'));
    if (sc && sc.items && sc.items.length === slis.length && slis.some(function (li, i) {
      var t = li.querySelector('.upcart-public-component-product-tile__product-title');
      if (t && GIFT_TITLE_RE.test(t.textContent)) return false;
      var ce = li.querySelector('.upcart-public-component-product-tile__price-compare-at');
      return ce && ce.getAttribute('data-hny-strike') !== String(unitStrike(sc.items[i]));
    })) return true;
    if (document.querySelector('.upcart-public-cart-item a[href*="/products/"]')) return true;
    var giftTitles = [].slice.call(document.querySelectorAll('.upcart-public-component-product-tile__product-title'))
      .filter(function (t) { return GIFT_TITLE_RE.test(t.textContent); });
    if (giftTitles.some(function (t) { return !t.closest('.upcart-public-cart-item').querySelector('.hny-freegift-pill'); })) return true;
    if (giftTitles.some(function (t) { return !t.closest('.upcart-public-cart-item').querySelector('.hny-freegift-desc'); })) return true;
    return [].slice.call(document.querySelectorAll('.upcart-public-cart-item')).some(function (li) {
      if (li.querySelector('.hny-li-detail')) return false;
      var props = li.querySelector('.upcart-public-component-product-tile__properties');
      if (!props) return false;
      return [].slice.call(props.querySelectorAll('[class*="key-value-pair"]'))
        .some(function (e) { return /supply\s*:|plan\s*:/i.test(e.textContent); });
    });
  }
  // ---- per-item strike: use the same anchor as the subtotal (unitStrike) so both match ----
  function fixItemStrikes() {
    var cart = window.upcartGetCart && window.upcartGetCart();
    if (!cart || !cart.items) return;
    var lis = document.querySelectorAll('.upcart-public-cart-item');
    if (lis.length !== cart.items.length) return; // avoid index misalignment
    cart.items.forEach(function (it, i) {
      var li = lis[i]; if (!li) return;
      if (GIFT_TITLE_RE.test(it.title || '')) return; // gifts keep their own $10/$20 strike
      var strike = unitStrike(it); // per-unit anchor
      var el = li.querySelector('.upcart-public-component-product-tile__price-compare-at');
      // the marker carries the value: when UpCart's async compareAtPrice lands later the
      // strike re-applies once, then marker == value => needsApply() false => no observer loop.
      // Marked even when strike=0, for the same reason as before.
      if (el && el.getAttribute('data-hny-strike') !== String(strike)) {
        el.setAttribute('data-hny-strike', String(strike));
        if (strike) el.textContent = fmt(strike);
      }
    });
  }

  // ---- subscription-aware free-shipping bar (subs ship free at any amount; one-time uses UpCart's $60 tier) ----
  function fixShippingBar() {
    var rewards = document.querySelector('.upcart-public-rewards');
    if (!rewards) return;
    var msg = rewards.querySelector('.upcart-public-rewards__message');
    if (cartHasSub) {
      rewards.classList.add('hny-ship-free');
      if (msg && msg.getAttribute('data-hny-ship') !== '1') {
        msg.setAttribute('data-hny-ship', '1');
        msg.innerHTML = 'Free shipping unlocked!';
      }
    } else {
      rewards.classList.remove('hny-ship-free');
      if (msg) msg.removeAttribute('data-hny-ship');
    }
  }
  function refreshShipFlag() {
    fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var items = (cart.items || []).filter(function (it) { return GIFT_VARIANTS.indexOf(it.variant_id) === -1; });
        cartHasSub = items.length > 0 && items.every(function (it) { return !!it.selling_plan_allocation; });
        fixShippingBar();
      }).catch(function () {});
  }
  function applyAll() { decorateSubtotal(); restyleLineItems(); labelGifts(); describeGifts(); disableItemLinks(); injectGuarantee(); fixShippingBar(); fixItemStrikes(); }

  function boot() {
    applyAll();
    enforceGiftGuard();
    refreshShipFlag();
    try {
      if (window.upcartSubscribeCartLoaded) window.upcartSubscribeCartLoaded(function () { applyAll(); enforceGiftGuard(); refreshShipFlag(); });
      if (window.upcartSubscribeCartUpdated) window.upcartSubscribeCartUpdated(function () { applyAll(); enforceGiftGuard(); refreshShipFlag(); });
      if (window.upcartSubscribeCartOpened) window.upcartSubscribeCartOpened(function () { setTimeout(applyAll, 60); });
    } catch (e) {}
    var pop = document.getElementById('CartPopup');
    if (pop && window.MutationObserver) {
      // debounce via setTimeout (a TASK, not a microtask): a synchronous applyAll
      // here creates an unbounded microtask chain when needsApply() flaps ->
      // main thread pegs -> cart freezes mid-slide, all buttons dead
      var pending = false;
      new MutationObserver(function () {
        if (pending || !needsApply()) return;
        pending = true;
        setTimeout(function () { pending = false; if (needsApply()) applyAll(); }, 50);
      }).observe(pop, { childList: true, subtree: true });
    }
  }
  if (document.readyState !== 'loading') setTimeout(boot, 800);
  else document.addEventListener('DOMContentLoaded', function () { setTimeout(boot, 800); });
})();
